(ns frontend.view.settings2.module-management.mcp-terms.view
  "The disclaimer that the tenant admin accepts before an MCP module is active."
  (:require
   [common.localization :as loc]
   [common.modules :as modules]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.settings2.module-management.mcp-terms.event :as event]
   [re-frame.core :as rf]
   [ui.color :as c]))

(def term-keys
  "Title and text keys of the eight terms, in the order that the modal shows."
  [[:settings/mcp-terms-1-title :settings/mcp-terms-1-text]
   [:settings/mcp-terms-2-title :settings/mcp-terms-2-text]
   [:settings/mcp-terms-3-title :settings/mcp-terms-3-text]
   [:settings/mcp-terms-4-title :settings/mcp-terms-4-text]
   [:settings/mcp-terms-5-title :settings/mcp-terms-5-text]
   [:settings/mcp-terms-6-title :settings/mcp-terms-6-text]
   [:settings/mcp-terms-7-title :settings/mcp-terms-7-text]
   [:settings/mcp-terms-8-title :settings/mcp-terms-8-text]])

(defn terms-required?
  "True when switching `module` on needs the acceptance of the MCP terms."
  [{:keys [active-modules module]}]
  (boolean (and (contains? modules/mcp-connector-modules module)
                (not (contains? (set active-modules) module)))))

(defn- terms-body
  []
  [:div
   {:class "flex flex-col gap-3 text-sm max-h-[60vh] overflow-auto"}
   [:p
    {:class "m-0"}
    (loc/tr :settings/mcp-terms-intro)]
   [:ol
    {:class "flex flex-col gap-2 pl-5 m-0"}
    (for [[title-key text-key] term-keys]
      ^{:key title-key}
      [:li
       [:span
        {:class "font-semibold"}
        (loc/tr title-key)]
       " "
       (loc/tr text-key)])]
   [:p
    {:class "m-0 text-base-light-text-paler"}
    (loc/tr :settings/mcp-terms-note)]])

(defn open-terms-modal!
  "Ask the tenant admin to accept the MCP terms before `module` is activated."
  [module]
  (modals/open-modal!
   confirmation-modal/modal-key
   {:title         (loc/tr :settings/mcp-terms-title)
    :body          [terms-body]
    :checkbox-text (loc/tr :settings/mcp-terms-checkbox)
    :confirm-text  (loc/tr :settings/mcp-terms-confirm)
    :confirm-color ::c/primary
    :on-confirm    #(rf/dispatch [::event/accept {:module module}])}))
